import React from "react";

import { Grid } from "@material-ui/core";
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

import alerter from "../../../alerts/alerter"

export default function KeyWords({ place, disable }) {
 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });


  const [keywords, setKeywords] = React.useState([...place.keywords]);
  const [keyword, setKeyword] = React.useState("");

  const addKeyword = () => {
    if (place.addKeyword(keyword.trim())) {
      setKeywords([...place.keywords]);
      setKeyword("");
    } else {
      alerter.showInfo("La palabra '" + keyword.trim() + "' ya se encuentra en el listado.")
    }
  }

  const removeKeyword = (position) => {
    place.removeKeyword(position);
    setKeywords([...place.keywords]);
  }

  const onChangeKeyword = (event) => {
    setKeyword(event.target.value);
  }

  return (

      <Grid container spacing={2} >
        <Grid item xs={true}>
          <TextField
            variant="outlined" 
            id="keyword"
            label="Palabra clave"
            name="keyword"
            value={keyword}
            disabled={disable}
            fullWidth
            onChange={onChangeKeyword}
            placeholder="Ingresa una palabra o frase descriptiva para mejorar las búsquedas"/>
        </Grid>
        <Grid item xs={'auto'}>
            <ThemeProvider theme={theme}>
              <Button 
                style={{height: '100%'}}
                disabled={keyword.trim().length === 0 || disable}
                startIcon={<AddIcon/>}
                variant="contained" 
                fullWidth
                onClick={addKeyword}>
              <b>Agregar</b>
            </Button>
          </ThemeProvider>
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'left'}}>
            { place.keywords.map((item, index) => (
                <Chip key={item} disabled={disable} style={{margin: '4px', fontSize: '15px'}} label={item} variant="outlined" onDelete={() => removeKeyword(index)}/>
              ))
            }
        </Grid>
      </Grid>

  );
}
